import React, { useEffect } from 'react';
import { MotionConfig } from 'framer-motion';
import { initMetaPixel } from './utils/metaPixel';
import { CountdownBar } from './components/CountdownBar';
import { Hero } from './components/Hero';
import { StatsBar } from './components/StatsBar';
import { Difference } from './components/Difference';
import { Recognize } from './components/Recognize';
import { WhatsInside } from './components/WhatsInside';
import { InsidePages } from './components/InsidePages';
import { Bonuses } from './components/Bonuses';
import { HowItWorks } from './components/HowItWorks';
import { Audience } from './components/Audience';
import { Offer } from './components/Offer';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { Faq } from './components/Faq';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    initMetaPixel();
    document.documentElement.lang = 'nb';
    document.title = 'MUSIKK KLAR™ – Ferdige musikktimer for 1.–10. trinn';
  }, []);
  return <MotionConfig reducedMotion="user" data-id="element-0" data-mp="3mk8710lxsfel">
      <div lang="nb" className="w-full bg-stone-50 font-sans text-slate-900 antialiased" data-id="element-1" data-mp="3mj6hxs835sdv">
        <CountdownBar data-id="element-2" data-mp="3recdlirailf5" />
        <main data-id="element-3" data-mp="5osn3wyp084">
          <Hero data-id="element-4" data-mp="6hpnd64cbd2" />
          <StatsBar data-id="element-5" data-mp="4wwnrzgd0hb" />
          <Difference data-id="element-6" data-mp="5gbgztt38r4" />
          <Recognize data-id="element-7" data-mp="7ssnarqpf34" />
          <WhatsInside data-id="element-8" data-mp="2zld4hgdhhrep" />
          <InsidePages data-id="element-9" data-mp="2zm4wkh7vh708" />
          <Bonuses data-id="element-10" data-mp="2zmwif0bo3qdb" />
          <HowItWorks data-id="element-11" data-mp="2zng0qi58cgrv" />
          <Audience data-id="element-12" data-mp="33mf0zpg0npcz" />
          <Offer data-id="element-13" data-mp="33nq6btp41567" />
          <Guarantee data-id="element-14" data-mp="33n6zp94wu37h" />
          <Testimonials data-id="element-15" data-mp="33orjq4tlm3r3" />
          <Faq data-id="element-16" data-mp="38m1fs3bhtdnw" />
          <FinalCta data-id="element-17" data-mp="38l8f9k34nke7" />
        </main>
        <Footer data-id="element-18" data-mp="38k6w0sbyjrle" />
      </div>
    </MotionConfig>;
}